import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import BookPrice from 'components/BookPrice/BookPrice';
import { clearSelectedAirlineSeats } from 'redux/actions/bookActions';
import PassengerListFlight from './PassengerListFlight';

import './PassengerList.scss';

const mapStateToProps = state => ({
  flights: state.bookState.getIn(['data', 'flight']),
  flightSeatsSelection: state.bookState.getIn(['booking_info', 'selection', 'flight_seats']),
  airlineSeatPassengers: state.bookState.getIn(['booking_info', 'airlineSeatPassenger']),
  bookSeatPrice: state.bookState.getIn(['priceBreakdown', 'airlineSeatPrice']),
  numberOfChargeablePassengers: state.bookState.getIn(['data', 'partyInfo', 'numberOfChargeablePassengers']),
});

const mapDispatchToProps = dispatch => ({
  clearSelection: direction => dispatch(clearSelectedAirlineSeats(direction)),
});

export class PassengerList extends PureComponent {
  static propTypes = {
    airlineSeatPassengers: ImmutablePropTypes.list.isRequired,
    flights: ImmutablePropTypes.map.isRequired,
    openSeatList: PropTypes.func.isRequired,
    flightSeatsSelection: ImmutablePropTypes.map.isRequired,
    bookSeatPrice: PropTypes.number,
    numberOfChargeablePassengers: PropTypes.number.isRequired,
    clearSelection: PropTypes.func.isRequired,
  };

  static defaultProps = {
    bookSeatPrice: 0,
  };

  render() {
    const {
      flights,
      openSeatList,
      flightSeatsSelection,
      airlineSeatPassengers,
      bookSeatPrice,
      numberOfChargeablePassengers,
      clearSelection,
    } = this.props;

    const directions = ['outbound', 'inbound'];
    const hasSeatsSelected = bookSeatPrice > 0;

    return (
      <div className="passenger-list">
        <div className="passenger-list__header">If you don&apos;t select your seats now, they&apos;ll be automatically allocated on check-in.</div>
        {
          directions.map((direction) => {
            const flight = flights.get(direction, Immutable.Map());
            return flight.get('flightSeatMap') ? (
              <PassengerListFlight
                direction={direction}
                flight={flight}
                key={direction}
                openSeatList={openSeatList}
                seatPassengers={airlineSeatPassengers}
                flightSeatsSelection={flightSeatsSelection.get(direction, Immutable.Map())}
                clearSelection={clearSelection}
              />
            ) : undefined;
          })
        }
        {
          hasSeatsSelected && (
            <div className="passenger-list__price-summary">
              <div className="passenger-list__price-summary__per-person">
                <BookPrice price={bookSeatPrice} divisor={numberOfChargeablePassengers} suffix="pp" isStrong hasSmallSuffix />
              </div>
              <div className="passenger-list__price-summary__total">
                Total: <BookPrice price={bookSeatPrice} isStrong />
              </div>
            </div>
          )
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PassengerList);



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/PassengerList.jsx
 **/